// const tenant = 'unob2c.onmicrosoft.com';

export const appConfig = {
  api: {

    apiUrl: "https://api.carrierappshub1.com/",

    // uiUrl: "https://dev.d2hor9274pjp8v.amplifyapp.com",
    // uiUrl : "https://residentialratingtool.carrier.com",
    uiUrl: "https://ai-se.carrier.com",

    postLogoutRedirectUri: "http://localhost:3000",
  },
  base_url: {
    local: "https://5xxznjdvq6.execute-api.us-east-1.amazonaws.com/local/api",
    test: "https://5xxznjdvq6.execute-api.us-east-1.amazonaws.com/local/api",
    prod: "https://pxc40xmnqa.execute-api.us-east-1.amazonaws.com/prod/api",
    pilot:"https://0gonzrljxe.execute-api.us-east-1.amazonaws.com/test/api"
  }
};
export default appConfig;
